import { render } from "./NextActivity.vue?vue&type=template&id=5fedefd8&scoped=true&lang=true"
import script from "./NextActivity.vue?vue&type=script&lang=js"
export * from "./NextActivity.vue?vue&type=script&lang=js"

import "./NextActivity.vue?vue&type=style&index=0&id=5fedefd8&lang=css&scoped=true"

import exportComponent from "C:\\laragon\\www\\icl-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fedefd8"]])

export default __exports__